export class DataCatalogTagAssignment {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DataCatalogTagResourceRef",
            "format": ""
        },
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdBy",
            "baseName": "createdBy",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogTagAssignment.attributeTypeMap;
    }
    constructor() {
    }
}
